import {
  Avatar,
  Button,
  Grid,
  makeStyles,
  AppBar,
  Toolbar,
  Tooltip,
  Menu,
  MenuItem,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileDetails } from "../actions/resource-management-actions";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import proPic from "../images/Card_Profile_Orange.svg";
import KirklandEllisLogo from "../images/KirklandLogo.png";
import profile from "../shared-resources/images/profile.jpg";
import {
  AdminSettings,
  GreenLogoLarge,
  HomeIcon,
  helpIcon,
  SettingsIcon,
} from "../shared-resources/SVGIcons";
import { logout } from "../actions/admin-actions";
import Loading from "../common-components/Loading";
import { getResponse, handleResourceRequest } from "../shared-resources/utils";
import { indirectHelpLinkUsers } from "../shared-resources/constants";

const useStyles = makeStyles((theme) => ({
  appBarShift: {
    width: `calc(100%)`,
    marginLeft: 200,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxShadow: "none !important",
    borderBottom: "2px solid #007FC6",
    background: "#fff",
  },
  rightIconsGrid: {
    textAlign: "right",
  },
  topRightIconProfile: {
    float: "right",
    cursor: "pointer",
    marginTop: "10px",
  },
  topRightIcon: {
    float: "right",
    cursor: "pointer",
    marginRight: "6px",
    marginTop: "12px",
  },
  topRightIconAdminSupport: {
    float: "right",
    cursor: "pointer",
    marginRight: "6px",
    marginTop: "14px",
  },
  topRightIconAdminSupportHome: {
    float: "right",
    cursor: "pointer",
    marginRight: "6px",
    marginTop: "14px",
  },
  topRightIconHome: {
    float: "right",
    cursor: "pointer",
    marginTop: "0px",
  },
  logoSection: {
    marginTop: "18px !important",
  },
  homeIcon: {
    margin: "18px 12px",
    cursor: "pointer",
    color: "#343434",
  },
  logOutBtn: {
    textTransform: "none",
    background: "#eb7738 !important",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    float: "right",
    marginTop: "12px",
  },
  profileBtn: {
    textTransform: "none",
    // color: "#0000 !important",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    float: "right",
    marginTop: "12px",
    marginRight: "8px",
    backgroundColor: "#ffff !important",
  },
  profileSettingsIcon: {
    width: "40px",
    height: "40px",
    minWidth: "40px",
  },
  userIcon: {
    width: "48px",
    height: "42px",
  },
  logoIcon: {
    height: "18px",
  },
}));

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({}))(MenuItem);

const Header = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [anchorElHelp, setAnchorElHelp] = useState(null);

  const logoutData = useSelector((state) => state.adminReducer.logoutData);
  const profileDetails = useSelector(
    (state) => state.resourceManagementReducer.profileDetails,
  );

  const handleClickHelp = (event) => {
    setAnchorElHelp(event.currentTarget);
  };

  const handleCloseHelp = () => {
    setAnchorElHelp(null);
  };

  const onHelpLinkClick = (type) => {
    setAnchorElHelp(null);
    if (type === "overall")
      window
        .open("https://nextquarter.storylane.io/share/1tioszpulmej", "_blank")
        .focus();
    else if (type === "indirect")
      window
        .open("https://nextquarter.storylane.io/share/ls6euhncz4ez", "_blank")
        .focus();
    else
      window
        .open("https://nextquarter.storylane.io/share/ojpapstsqm2t", "_blank")
        .focus();
  };

  const getUserInfo = () => {
    if (
      profileDetails &&
      profileDetails.data &&
      Array.isArray(profileDetails.data.data)
    ) {
      return profileDetails.data.data.reduce((info, field) => {
        info[field.fieldName.toLowerCase()] = field.fieldValue;
        return info;
      }, {});
    }
    return {};
  };

  const onHomeClick = () => {
    if (handleResourceRequest()) history.push("/");
  };

  const onLogoClick = () => {
    if (handleResourceRequest()) history.push("/");
  };

  const onSettingsClick = () => {
    if (handleResourceRequest()) history.push("/settings/financial-management");
  };

  const onProfileClick = () => {
    if (handleResourceRequest()) history.push("/user-profile");
  };

  const onAdminSupportClick = () => {
    if (handleResourceRequest()) history.push("/admin-support");
  };

  const onLogoutClick = () => {
    dispatch(logout());
    setLoading(true);
  };

  useEffect(() => {
    if (
      logoutData &&
      logoutData.status &&
      (logoutData.status === 200 || logoutData.status === 400)
    ) {
      localStorage.clear();
      setTimeout(() => (window.location.href = "/logout"), 100);
    }
  }, [logoutData]);
  // useEffect(() => {
  //   setLoading(true);
  //   // setUserId(localStorage.getItem("email"));
  //   dispatch(getUserProfileDetails(localStorage.getItem("email")));
  // }, []);
  useEffect(() => {
    if (
      profileDetails &&
      profileDetails.status &&
      profileDetails.status === 200
    ) {
      setLoading(false);
      setUserInfo(getUserInfo());
    }
    if (profileDetails.status === 400) {
      setLoading(false);
      setUserInfo([]);
    }
  }, [profileDetails]);
  return (
    <AppBar position="fixed" className={classes.appBarShift}>
      <Toolbar>
        <Grid container>
          <Grid item xs={12} lg={6} className={classes.logoSection}>
            <span onClick={() => onLogoClick()} style={{ cursor: "pointer" }}>
              <img
                src={KirklandEllisLogo}
                alt="Logo"
                className={classes.logoIcon}
              />
            </span>
          </Grid>
          <Grid item xs={12} lg={6} className={classes.rightIconsGrid}>
            <span className={classes.logoutBtnSection}>
              <Button
                className={classes.logOutBtn}
                variant="contained"
                color="primary"
                onClick={onLogoutClick}
                title="Logout"
              >
                <ExitToAppIcon className={classes.logOutIcon} />
              </Button>
            </span>

            {localStorage.getItem("isSuperUser") &&
              JSON.parse(localStorage.getItem("isSuperUser")) && (
                <>
                  {location.pathname.includes("settings") && (
                    <span
                      onClick={onHomeClick}
                      className={classes.topRightIconAdminSupport}
                      title="Dashboard"
                    >
                      {SettingsIcon("#999797", 36, 36)}
                    </span>
                  )}
                  {!location.pathname.includes("settings") && (
                    <span
                      onClick={onSettingsClick}
                      className={classes.topRightIconAdminSupport}
                      title="Admin"
                    >
                      {SettingsIcon("#999797", 36, 36)}
                    </span>
                  )}
                </>
              )}
            {/* {localStorage.getItem("roles") &&
              JSON.parse(localStorage.getItem("roles")).includes("CIO") && ( */}
            <>
              {profileDetails.status !== 400 && (
                <>
                  {location.pathname.includes("/user-profile") && (
                    <div title="Home">
                      <Button
                        className={classes.profileBtn}
                        variant="contained"
                        onClick={onHomeClick}
                      >
                        <img
                          src={proPic}
                          alt="Profile Icon"
                          className={classes.userIcon}
                        />
                      </Button>
                    </div>
                  )}
                  {/*{!location.pathname.includes("/user-profile") && (
                    <span className={classes.logoutBtnSection}>
                      <Tooltip
                        title={`${userInfo["first name"]} ${userInfo["last name"]}`}
                        arrow
                      >
                        <Button
                          className={classes.profileBtn}
                          variant="contained"
                          onClick={onProfileClick}
                        >
                          <img
                            src={proPic}
                            alt="Profile Icon"
                            className={classes.userIcon}
                          />
                        </Button>
                      </Tooltip>
                    </span>
                  )}*/}
                </>
              )}
              <span
                className={classes.topRightIcon}
                title="Help"
                onClick={handleClickHelp}
              >
                {helpIcon()}
              </span>
              <StyledMenu
                id="simple-menu"
                anchorEl={anchorElHelp}
                keepMounted
                open={Boolean(anchorElHelp)}
                onClose={handleCloseHelp}
              >
                <StyledMenuItem onClick={() => onHelpLinkClick("overall")}>
                  Product Walkthrough
                </StyledMenuItem>
                {indirectHelpLinkUsers.includes(
                  localStorage.getItem("email"),
                ) && (
                  <StyledMenuItem onClick={() => onHelpLinkClick("indirect")}>
                    Indirect
                  </StyledMenuItem>
                )}
                <StyledMenuItem onClick={() => onHelpLinkClick("template")}>
                  Upload Template
                </StyledMenuItem>
              </StyledMenu>

              {/*{localStorage.getItem("roles") &&
                (JSON.parse(localStorage.getItem("roles")).includes("RM") ||
                  JSON.parse(localStorage.getItem("roles")).includes(
                    "ADMIN"
                  )) && (
                  <>
                    {location.pathname.includes("admin-support") ? (
                      <span
                        onClick={onHomeClick}
                        className={classes.topRightIconAdminSupport}
                        title="Home"
                      >
                        {SettingsIcon("#999797")}
                      </span>
                    ) : (
                      <span
                        onClick={onAdminSupportClick}
                        className={classes.topRightIconAdminSupport}
                        title="Admin Support"
                      >
                        {SettingsIcon("#999797")}
                      </span>
                    )}
                  </>
                )}*/}
            </>
            {/* )} */}
          </Grid>
        </Grid>
      </Toolbar>
      {loading ? <Loading /> : ``}
    </AppBar>
  );
};

export default Header;
